// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_fW","advertDetailService__price":"c-p_fX"};